export default __webpack_public_path__ + "static/media/Regional_on.76a67a02.svg";